import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import App from './app/App/App.jsx';
import '../common/styles/config.less';
import '../styles/index.less';
import { AppContainer } from 'react-hot-loader';
import { Responsive } from 'react-plan';

render(<AppContainer><Responsive><App /></Responsive></AppContainer>, document.getElementById('root'));

if(module.hot) {
  module.hot.accept('./app/App/App.jsx', () => {
    const App = require('./app/App/App.jsx').default;
    render(<AppContainer><Responsive><App /></Responsive></AppContainer>, document.getElementById('root'));
  });
}


/** WEBPACK FOOTER **
 ** ./src/js/index.js
 **/